import { Button, Card, Col, Row } from 'react-bootstrap';
import { useState } from 'react';
import ServerPagedTable from '../../../../components/table/ServerPagedTable';
import useServerPagedData from '../../../../components/table/useServerPagedData';
import { GetHubMetroMappingDto } from '../../hub-metro-mapping/types/GetHubMetroMappingDto';
import { CellProps, Column } from 'react-table';
import { SortCodeMappingConfigurationDto, SortCodeMappingDto } from '../dtos/SortContainerDto';
import AddSortCodeConfig from '../add-sort-code-config';
import RemoveSortCodeConfig from '../remove-sort-code-config';

type FormInputs = {
    filterBy: string | null;
    search: string | null;
};

const SortConfiguration = () => {
    const [selectedConfiguration, setSelectedConfiguration] = useState<any>(null);
    const [addOrUpdateSortConfiguration, setAddOrUpdateSortConfiguration] = useState<boolean>(false);
    const [deleteSortCodeConfig, setDeleteSortCodeConfig] = useState<boolean>(false);

    const onOpenNew = () => {
        setSelectedConfiguration(null);
        setAddOrUpdateSortConfiguration(true);
    };

    const [searchParams, setSearchParams] = useState<{
        searchProperty?: string;
        searchValue?: string;
        pageNumber?: string;
    }>({});

    const styleMetroCodes = (value: string): JSX.Element[] => {
        if (!value || value.trim() === '') {
            return [];
        }

        const metroCodes = value.split(',');
        const rows = [];
        const itemsPerRow = 5; // Define how many items per row you want

        for (let i = 0; i < metroCodes.length; i += itemsPerRow) {
            const rowItems = metroCodes.slice(i, i + itemsPerRow).map(company => (
                <span key={company.trim()} className="me-2 bg-info badge bg-primary badge-lg mb-2">
                    {company.trim()}
                </span>
            ));
            // Wrap each group of three items in a new div
            rows.push(
                <div key={i} style={{ display: 'block', clear: 'both' }}>
                    {rowItems}
                </div>,
            );
        }

        return rows;
    };

    const onOpenEdit = (original: any): any => {
        let sortCodeIds = original.sortCodeMappings.map((m: any) => m.companySortCodeId).join(",");
        setSelectedConfiguration({ id: original.id, name: original.name, sortCodeIds: sortCodeIds });
        setAddOrUpdateSortConfiguration(true);
    };

    const onOpenDeleteConfirmation = (original: any): any => {
        setSelectedConfiguration(original);
        setDeleteSortCodeConfig(true);
    };

    const {
        tableResult,
        dataLoading,
        serverPageParams,
        setServerPageParams,
        getData,
    } = useServerPagedData<SortCodeMappingConfigurationDto>('api/SortCodeConfig', searchParams);

    const columns: ReadonlyArray<Column> = [
        {
            Header: 'Group Name',
            accessor: `name`,
            defaultCanSort: true,
        },
        {
            Header: 'Sort Codes in Group',
            accessor: 'sortCodeMappings',
            defaultCanSort: true,
            Cell: ({ value }) => {
                return (
                    <div style={{ maxWidth: '150px' }}>
                        {styleMetroCodes((value as SortCodeMappingDto[]).map((item) => item.companySortCodes.sortCode).join(', '))}
                    </div>
                );
            },
        },
        {
            Header: 'Options',
            accessor: '*',
            Cell: (props: CellProps<GetHubMetroMappingDto>) => {
                return (
                    <Row className="justify-content-center">
                        <Col xs="auto">
                            <div className="d-flex justify-content-center">
                                <Button type="button" variant="info" onClick={() => onOpenEdit(props.row.original)}>
                                    <i className="mdi mdi-pencil"></i> Edit
                                </Button>
                            </div>
                        </Col>
                        <Col xs="auto">
                            <div className="d-flex justify-content-center">
                                <Button
                                    type="button"
                                    variant="info"
                                    onClick={() => onOpenDeleteConfirmation(props.row.original)}>
                                    <i className="mdi mdi-trash-can"></i> Delete
                                </Button>
                            </div>
                        </Col>
                    </Row>
                );
            },
        },
    ];

    return (
        <>
            <div className="col">
                <div style={{ display: 'flex', alignItems: 'center' }}>
                    <div className="page-title-box" style={{ width: '100%' }}>
                        <div className="page-title-right">
                            <nav aria-label="breadcrumb">
                                <Col xs="auto">
                                    <Button
                                        className="btn btn-sm btn-rounded btn-create-new-rule"
                                        onClick={() => onOpenNew()}>
                                        Add New Sort Configuration
                                    </Button>
                                </Col>
                            </nav>
                        </div>
                    </div>
                </div>
            </div>
            <br />
            <Card>
                <Card.Body className="p-0">
                    <ServerPagedTable
                        tableResult={tableResult}
                        dataLoading={dataLoading}
                        serverPageParams={serverPageParams}
                        setServerPageParams={setServerPageParams}
                        columns={columns}
                        isSortable={true}
                        pagination={true}
                    />
                </Card.Body>
            </Card>

            {addOrUpdateSortConfiguration && (
                <AddSortCodeConfig
                    payload={selectedConfiguration}
                    updateTable={() => getData()}
                    show={true}
                    toggle={() => {
                        setAddOrUpdateSortConfiguration(false);
                    }}></AddSortCodeConfig>
            )}

            {deleteSortCodeConfig && (
                <RemoveSortCodeConfig
                    payload={selectedConfiguration}
                    updateTable={() => getData()}
                    show={true}
                    toggle={() => {
                        setDeleteSortCodeConfig(false);
                    }}></RemoveSortCodeConfig>
            )}
        </>
    );
};

export default SortConfiguration;